/* various objects dealing with goals */

import { orZero } from "app/lib/utils/NumUtils";

// Calculated goal rules:
// cppGoal = [(revenueGoal) / (merGoal)] / [(revenueGoal) / (aovGoal)]

export enum Goal {
    Revenue = 'Revenue',
    Adspend = 'Adspend',
    Cpp = 'CPP',
    Aov = 'AOV',
    Roas = 'ROAS',
    Mer = 'MER',
    Products = 'Products',
    Orders = 'Orders'
}

export enum MetricRange {
    Daily = 'Daily',
    Previous7 = 'Previous 7',
    LastMonth = 'Last Month',
    LastYear = 'Last Year',
}

// Contains/represents goals for an account
export class Goals {

    goals = NEW_DEFAULT_GOALS();

    constructor(goals?) {
        this.loadGoals(goals);
    }

    loadGoals = (goals) => {
        this.goals.orders = orZero(goals?.orders);
        this.goals.revenue = orZero(goals?.revenue);
        this.goals.adspend = orZero(goals?.adspend);
        this.goals.cpp = orZero(goals?.cpp);
        this.goals.aov = orZero(goals?.aov);
        this.goals.roas = orZero(goals?.roas);
        this.goals.mer = orZero(goals?.mer);
        this.goals.products = orZero(goals?.products);
        this.goals.purchases = orZero(goals?.purchases);
        return this;
    }

    getGoals = () => {
        return this.goals;
    }

    // Returns a standard object representation
    getGoal = (goal) => {
        if (typeof this.goals[goal] == 'undefined')
            console.warn(`Warning: Goal ${goal} is an unknown goal type, trying to set value: ${value}`);
        return this.goals[goal];
    }

    setGoal = (goal, value) => {
        if (typeof this.goals[goal] == 'undefined')
            console.warn(`Warning: Goal ${goal} is an unknown goal type, trying to set value: ${value}`);
        this.goals[goal] = value;
        return this;
    }
}

export const NEW_DEFAULT_GOALS = () => {
    return {
        orders: 0,
        revenue: 0,
        adspend: 0,
        cpp: 0,
        aov: 0,
        roas: 0,
        mer: 0,
        products: 0,
        purchases: 0
    }
}